export default "__VITE_ASSET__Cpwp0zi5__"